import { Component, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import * as _ from 'lodash';

import { DataService } from '../../../../../../../infrastructure/services/base/config/data.service';

declare var jQuery: any;

@Component({
  selector: 'loading-booking',
  //template: '<router-outlet></router-outlet>',
  templateUrl: './loading-booking.html',
  providers: [DataService],

})
export class LoadingBookingComponent implements OnInit, AfterViewInit {
  Title: string = 'Loading Bay Booking';
  TitleDesc: string = 'To make an book, please click on a date to select';
  BreadcrumbActive = 'Loading Booking';
  TitleBox = ' Loading Schedule';

  Accounts: any[] = [];


  constructor(private dtService: DataService, private cd: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.setAccounts();

  }

  ngAfterViewInit() {
    var date = new Date();
    var d = date.getDate(),
      m = date.getMonth(),
      y = date.getFullYear();
    jQuery('#PopupAddBook').modal({ "show": false });


    jQuery('#calendar').fullCalendar({
      header: {
        left: 'prev,today,next',
        center: 'title',
        right: ''
      },
      firstDay: 1,
      buttonText: {
        today: 'Today',
        month: 'month',
        week: 'week',
        day: 'day',
        prev: '< Prev',
        next: 'Next >'
      },
      dayClick: function (date, jsEvent, view) {
        jQuery('#PopupAddBook').modal("show");
      },
      dayRender: function (date, cell) {
        var checkDay = new Date(date);
        if (checkDay.getDay() === 0) cell.css("background-color", "#F8E0E0");
      },
      events: [
        {
          title: 'All Day Event',
          start: new Date(y, m, 1),
          backgroundColor: "#f56954", //red
          borderColor: "#f56954" //red
        },
        {
          title: 'Long Event',
          start: new Date(y, m, d - 5),
          end: new Date(y, m, d - 2),
          backgroundColor: "#f39c12", //yellow
          borderColor: "#f39c12" //yellow
        },
        {
          title: 'Meeting',
          start: new Date(y, m, d, 10, 30),
          allDay: false,
          backgroundColor: "#0073b7", //Blue
          borderColor: "#0073b7" //Blue
        },
        {
          title: 'Lunch',
          start: new Date(y, m, d, 12, 0),
          end: new Date(y, m, d, 14, 0),
          allDay: false,
          backgroundColor: "#00c0ef", //Info (aqua)
          borderColor: "#00c0ef" //Info (aqua)
        },
        {
          title: 'Birthday Party',
          start: new Date(y, m, d + 1, 19, 0),
          end: new Date(y, m, d + 1, 22, 30),
          allDay: false,
          backgroundColor: "#00a65a", //Success (green)
          borderColor: "#00a65a" //Success (green)
        },
        {
          title: 'Click for Google',
          start: new Date(y, m, 28),
          end: new Date(y, m, 29),
          url: 'http://google.com/',
          backgroundColor: "#3c8dbc", //Primary (light-blue)
          borderColor: "#3c8dbc" //Primary (light-blue)
        }
      ],
    });


    jQuery('.fc-day-header.ui-widget-header.fc-sun').css("background-color", "red");

  }

  setAccounts(): void {
    this.dtService.getJSON("../../../assets/mock-data/account.json")
      .subscribe(
      data => this.Accounts = data.Account,
      error => console.log(error),
      // () => console.log("Finished Call Accounts") 
    );
  }
}


export class MyEvent {
  id: number;
  title: string;
  start: string;
  end: string;
  allDay: boolean = true;
}


// WEBPACK FOOTER //
// ./src/app/views/pages/transaction/op/outbound/booking/loading-booking/loading-booking.component.ts